import React, { useContext } from 'react';

export const EntryContext = React.createContext({
    entry: {
        id: null,
        name: null,
        metaData: {},
        hasEntered: false
    },
    setEntry: () => {}
});

export const useEntry = () => useContext(EntryContext);
